import React, { PureComponent } from 'react';
import { TouchableOpacity, View } from 'react-native';
import Button from '@dbk/ui-buttons';
import debounce from 'lodash/debounce';
import { createContainer } from '@dbk-legacy/muster/react'
import Text, { H1, H3 } from '@dbk/ui-text'
import {
  NavigationListItem,
  NavigationListItemHeader,
  NavigationListItemFooter,
  NavigationListItemContent
} from '@dbk/ui-list'
import Modal from '@dbk/ui-modal';
import Search from '@dbk/ui-search';
import ScrollTopOnMount from '../../../components/common/scroll-top-on-mount'
import { PALETTE, ROUTES, KEY_CODE } from '../../../constants';
import { ErrorIcon } from '../../../components/common/icons';
import { LoadingCircle } from '../../../components/common/loading';
import paymentData from '../../../data/paymenttypes.json';
import PaymentTouchableListItem from '../payment-touchable-list-item';
import  { PAYMENT_TYPE } from '../../../screens/payments/constant';
import { Currency } from '../../../components/common/number';
import styles from './payment-template.styles';

const DEBOUNCE_TIME = 800;

const { NEW_DOMESTIC, LOADING } = ROUTES.PAYMENT;
class PaymentTemplate extends PureComponent {
  state = {
    enableSearch: false,
    searchResult: [],
    searchText: '',
    deleteItem: ''
  }

  async componentWillMount() {
    await this.props.payments.loadSpinner(true);
  }

  async componentDidMount() {
    await this.props.payments.getTemplateList();
  }

  componentDidUpdate(prevProps) {
    if (this.props.payments.templateList !== prevProps.payments.templateList && this.state.searchText.length > 0) {
      this.handleSearchChange(this.state.searchText);
    }
    if(document.querySelector('.onDeleteTemplateTextFocus')){
      document.querySelector('.onDeleteTemplateTextFocus').focus();
    }
  }

  renderErrorModal = () => {
    const { payments: { errorMsg } } = this.props;
    return (
      <Modal
        isActive
        onClose={() => this.props.payments.setErrorModal(false)}
        content={
          <div className="small-12 row padding-20">
            <div className="column small-1">
              <ErrorIcon width={30} height={30} />
            </div>
            <div className="column small-11">
              <Text>{errorMsg}</Text>
            </div>
          </div>
        }
      />
    )
  }

  // Function to display search result
  handleSearchChange = (text) => {
    const {
      payments: { templateList }
    } = this.props;
    var resultantArray = [];
    const searchText = text.toUpperCase();
    if (templateList.length > 0) {
      templateList.map(item => {
        if (item.templateName.toUpperCase().includes(searchText)) {
          resultantArray.push(item);
        }
      })
    }
    this.setState({
      enableSearch: true,
      searchResult: resultantArray,
      searchText: text
    });
  }


  confirmModal = () => {
    this.props.payments.deleteTemplate(this.state.deleteItem);
  }

  closeModal = () => {
    this.props.payments.setDelConfirmationModal(false);
  }

  // Function called on click of delete button on template
  deleteBeneficiary = (event, item) => {
    this.props.payments.setDelConfirmationModal(true);
    this.setState({ deleteItem: item.templateId })
    event.stopPropagation();
  }

  // Deletion confirmation modal
  showDeleteConfModal = () => {
    const { i18n: { messages } } = this.props;
    return (
      <Modal
        isActive={this.props.payments.deleteConfirmationModal}
        onClose={this.closeModal}
        header={messages['app.payment.templates.delete.title']}
        className={"model-window-login"}
        content={
          <div className="padding-20">
            <span tabIndex={0} className="onDeleteTemplateTextFocus">
            <Text>{messages['app.payment.templates.delete.body']}</Text>
            </span>
            <div className="text-right margin-top-20">
              <Button
                tertiary
                onPress={this.closeModal}
                size="large">
                {messages['app.common.alert.no']}
              </Button>
              <Button
                onPress={this.confirmModal}
                size="large"
                loading={this.props.payments.loading}>
                {messages['app.common.alert.yes']}
              </Button>
            </div>
          </div>
        }
      />)
  }

  // Function on selection of any Payment template
  templateDetail = async (row, e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      this.props.payments.loadSpinner(true);
      this.props.payments.selectedPaymentTemplate(row);
      this.props.payments.setTemplateName(row.templateName);
      this.props.payments.setIsSaveEnabled(false);
      //const psPosId = this.props.payments.psPosId;
      // display a loading circle
      await this.props.payments.initializeTx(row.paymentType);
      if (row.paymentType.includes('internal')) this.props.payments.setSelectCreditAccFlag(true)

    setTimeout(() => {
        const { initializeTxFails } = this.props.payments;
        this.props.payments.loadSpinner(false);
        if (initializeTxFails) {
          let failMsg = this.props.i18n.messages['app.payments.failToConnect']
          this.props.payments.setErrorModal(true);
          if (initializeTxFails === 'payments.error.active.webtxn') {
            failMsg = this.props.i18n.messages['app.payment.error.active.webtxn']
          } else if (initializeTxFails === 'acp.down') {
            failMsg = this.props.i18n.messages['app.payment.error.acp.down']
          }
          this.props.payments.setErrorMsg(failMsg);
        } else {
          this.props.payments.initializePaymentCapture();
          this.props.changePage(NEW_DOMESTIC);
        }
      }, 100);
    }
  }

  /* Function to get displayed payment type */
  getPaymentTypeName = paymentType => {
    const paymentTypeObj = paymentData.options.find(e => e.key===paymentType)
    return this.props.i18n.messages[paymentTypeObj.title]
  }

  render() {
    const {
      i18n: { messages },
      auth: {addBeneficiaryDisabled},
      payments: { templateList, loading, templateErrorModal },
    } = this.props;
    const resultantData = this.state.enableSearch ? this.state.searchResult : templateList;

    if (loading)
      return <LoadingCircle isPage />;

    return (
      <div className="payment-page__destination row">
        <ScrollTopOnMount />
        <div className="title">
          <H1 tabIndex={0} >{messages['app.payment.templates.pageTitle']}</H1>

          <div className="search--header">
            <div className='search--container'>
              <Search
                value={this.state.searchText}
                size={"large"}
                placeholder={messages['app.payment.search']}
                onChange={debounce(this.handleSearchChange, DEBOUNCE_TIME)}
                className="search-button"
                aria-label={messages['app.payment.templateSearch']}
              />
            </div>
          </div>
        </div>
        {resultantData && resultantData.length < 1 && !this.state.enableSearch && <H3 tabIndex={0} className="noTemplate">{messages['app.payment.templates.noTemplate']}</H3>}
        {resultantData && resultantData.length > 0 &&
          resultantData.map(item => (
            <TouchableOpacity onPress={(e) => this.templateDetail(item, e)} accessible={false}>
              <NavigationListItem role="none" tabIndex={-1} inverse hasArrow={false} onClick={() => this.templateDetail(item)}>
                <PaymentTouchableListItem deleteItem={this.deleteBeneficiary} item={item} editVisible={false} addBeneficiaryDisabled={addBeneficiaryDisabled}>
                  <NavigationListItemHeader tabIndex={0}>
                    <View style={styles.templateNameContainer}>
                      <Text className={"ben-header-name"}>{item.templateName}</Text>
                      </View>
                    <View style={styles.currencyContainerStyle}>
                      <NavigationListItemContent tabIndex={0}>
                        <Currency
                          currency={item.currencyTech}
                          value={item.amount}
                          renderProps={{
                            // size: 'normal',
                            style: styles.currencyStyle
                          }}
                        />
                      </NavigationListItemContent>
                    </View>
                  </NavigationListItemHeader>
                  <NavigationListItemFooter tabIndex={this.getPaymentTypeName(item.paymentType)?"0":"-1"}>{this.getPaymentTypeName(item.paymentType)}</NavigationListItemFooter>
                  <NavigationListItemFooter tabIndex={(!item.paymentType.includes(PAYMENT_TYPE.internal) && item.firstName)?"0":"-1"}>{!item.paymentType.includes(PAYMENT_TYPE.internal) &&
                    item.firstName + ' ' + (item.lastName ? item.lastName : '')}
                  </NavigationListItemFooter>
                  <NavigationListItemFooter tabIndex={0}>
                    <Text>{messages['app.common.portfolio.bonds.account']}{": "}{item.paymentType.includes(PAYMENT_TYPE.internal)?item.toCashAccNo:(item.accountNo ? item.accountNo : item.ibanNo)}</Text>
                  </NavigationListItemFooter>
                  <NavigationListItemFooter tabIndex={item.bank?"0":"-1"}>
                    {item.bank}
                  </NavigationListItemFooter>
                </PaymentTouchableListItem>
              </NavigationListItem>
            </TouchableOpacity>
          ))}
        <div className="footer-placeholder" />
        {templateErrorModal && this.renderErrorModal()}
        {this.props.payments.deleteConfirmationModal && this.showDeleteConfModal()}
      </div>
    )
  }
}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    auth: {
      addBeneficiaryDisabled: true
    },
    changePage: { $call: 'ui.history.push' },
    payments: {
      deleteTemplate: { $call: 'deleteTemplate' },
      templateList: true,
      setTemplateList: { $set: 'templateList' },
      getTemplateList: { $call: 'getTemplateList' },
      loadSpinner: { $set: 'loading' },
      templateErrorModal: true,
      setErrorModal: { $set: 'templateErrorModal' },
      loading: true,
      errorMsg: true,
      setErrorMsg: { $set: 'errorMsg' },
      deleteConfirmationModal: true,
      setDelConfirmationModal: { $set: 'deleteConfirmationModal' },
      selectedPaymentTemplate: { $set: 'selectedPaymentTemplate' },
      initializeTx: { $call: 'initializeTx' },
      psPosId: true,
      setPosId: { $set: 'psPosId' },
      initializeTxFails: true,
      selectCreditAccFlag: true,
      setSelectCreditAccFlag: { $set: 'selectCreditAccFlag' },
      initializePaymentCapture: { $call: 'initializePaymentCapture' },
      setTemplateName: {$set: 'templateName'},
      setIsSaveEnabled: { $set: 'isSaveEnabled'}
    },
  },
})(PaymentTemplate)
